<template>
  <section class="highlights">
    <div class="container">
      <a-typography-title :level="1">
        方案亮点功能
      </a-typography-title>
      <div class="center">
        <div class="bg" v-if="$Store.Public().isGridMatch('>',$Enum.GridEnum.XL)">
          <img :src="file.centerImage" alt="" />
        </div>
        <div class=" center_list">
          <div v-for="(item,index) in expand.list" :key="index" class="item">
            <div :class="'item_title_'+(index+1)">
              {{item.title}}
            </div>
            <div class="item_text">
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_free button_n_1"  @click="$Store.Page().openModal('modalOperate','freeUse')">
          免费体验
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";
import centerImage from "@resource/image/page/planTrusteeship/highlights_content.png";

export default {
  name: "trusteeship_highlights",
  data(): DataInterface {
    return {
      file: {
        centerImage,
      },
      expand: {
        list: [
          {
            title: "安全性保障",
            text: "公有云上资源，为企业提供独立的VPC，保障业务独立性；专有云上，采用标准的虚拟化技术进行租户隔离，可为企业提供独占的物理机资源。",
          },
          {
            title: "稳定性保障",
            text: "企业也可选择将业务全部托管在星汉未来的运维平台，由平台提升保障业务稳定性。",
          },
          {
            title: "全托管一站式",
            text: "经过充分评估和企业许可，星汉未来的专家团队为企业提供一站式业务的改造和迁移；迁移过程中，业务无损，无需停服，实现一站式无缝全托管。",
          },
        ],
      },
    };
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@imagePublic: "@{src_image}page/public/";
@image: "@{src_image}page/planTrusteeship/";

.highlights {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg("@{image}highlights.jpg");
  background-size: cover;

  .container {
    position: relative;
    max-width: @grid_xl;
    margin: 50px auto;
    .borderBox();
    text-align: center;
    .center {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 50px;
      .bg {
        position: relative;
        flex: none;
        width: 640px;
        height: 560px;
        img {
          width: 640px;
          height: 640px;
          position: absolute;
          top: -80px;
          left: -40px;
        }
      }
      &_list {
        .item {
          @wh: 35px;
          margin: 40px 0;
          position: relative;
          padding-left: 50px;
          .icon(@icon:"center_icon1.png",@w,@h) {
            margin-bottom: 16px;
            .font(left, @title_mo, @color_7, @title_mo);
            &::before {
              content: "";
              display: block;
              .position(absolute, 0, auto, auto, 0);
              z-index: 0;
              width: @w;
              height: @h;
              .bg("@{image}@{icon}",@w, @h);
            }
          }
          &_title_1 {
            .icon("center_icon1.png",28px,30px);
          }
          &_title_2 {
            .icon("center_icon2.png",30px,28px);
          }
          &_title_3 {
            .icon("center_icon3.png",32px,28px);
          }
          &_text {
            .font(left, @title_mo, @color_7, @text);
          }
        }
      }
    }
    .button_n_free {
      @ah: 40px;
      .font(center, @ah, @color_black, @text,true) !important;
    }
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_2, @title, true);
}

.ant-row {
  margin: 0;
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .ant-row {
    margin: 30px 0 0;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .highlights {
    .container {
      padding: @space_mo 0;
      margin: 0 auto;
      .center {
        margin-top: @space_mo;
      }
    }
  }

  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_2, @title_mo, true);
  }

  .ant-row {
    margin: @margin_mo 0 0;
  }

  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>